import React from "react";
import { Link } from "react-router-dom";
import PageSEO from "../components/seo/PageSEO";
import "../styles/page.css";

export default function NotFound() {
  return (
    <main className="page">
      <PageSEO title="Not Found | Your App Name" description="Page not found." path="/404" noindex />
      <header className="pageHeader">
        <h1>Not Found</h1>
        <p>The page you requested doesn't exist.</p>
        <div style={{ marginTop: 18 }}>
          <Link className="btn btn--primary" to="/">Go Home</Link>
        </div>
      </header>
    </main>
  );
}
